@let scenario = editingScenarioSg();

<div class="atn-scenario-general-tab">
  <atn-ds-text
    label="Name"
    placeholder="E.g. 'Main' or 'FY2025 - Conservative'"
    [value]="scenario?.name ?? ''"
    (change)="editScenario('name', $event ?? '')"
    data-test-id="nameLabel"
  />
  <atn-ds-text
    label="Alias"
    placeholder="E.g. 'main' or '2025-consv'"
    [value]="scenario?.alias ?? ''"
    (change)="editScenario('alias', $event ?? '')"
    data-test-id="aliasLabel"
  />
  <!-- TODO: this is temporary hidden, should be uncommented after fix this AA-1083 -->
  <!-- <div class="atn-scenario-general-tab__visibility-options">
    <atn-ds-radio-options (change)="scenarioVisibilityChangeHandler($event)">
      <atn-ds-pill-button
        [isActive]="radioValueSg() === scenarioVisibilityEnum.Pinned"
        [radioValue]="scenarioVisibilityEnum.Pinned"
      >
        <i
          [class]="[
            'atn-icon atn-pin',
            radioValueSg() === scenarioVisibilityEnum.Pinned
              ? 'atn-light'
              : 'atn-blue'
          ]"
        ></i>
        <span>{{
          scenarioVisibilityEnum.getName(scenarioVisibilityEnum.Pinned)
        }}</span>
      </atn-ds-pill-button>

      <atn-ds-pill-button
        [isActive]="radioValueSg() === scenarioVisibilityEnum.Visible"
        [radioValue]="scenarioVisibilityEnum.Visible"
      >
        <i
          [class]="[
            'atn-icon atn-cluster',
            radioValueSg() === scenarioVisibilityEnum.Visible
              ? 'atn-light'
              : 'atn-blue'
          ]"
        ></i>
        <span
          >{{
            scenarioVisibilityEnum.getName(scenarioVisibilityEnum.Visible)
          }}
          (Default)</span
        >
      </atn-ds-pill-button>

      <atn-ds-pill-button
        [isActive]="radioValueSg() === scenarioVisibilityEnum.Hidden"
        [radioValue]="scenarioVisibilityEnum.Hidden"
      >
        <i
          [class]="[
            'atn-icon atn-hide',
            radioValueSg() === scenarioVisibilityEnum.Hidden
              ? 'atn-light'
              : 'atn-blue'
          ]"
        ></i>
        <span>{{
          scenarioVisibilityEnum.getName(scenarioVisibilityEnum.Hidden)
        }}</span>
      </atn-ds-pill-button>
    </atn-ds-radio-options>
  </div> -->
</div>
